/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "reverse": {
            "nested": {
              "ReverseError": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "INVALID_CREATOR": 1,
                  "ALREADY_CAPTURED": 2,
                  "AUTH_FAILED": 6,
                  "PURCHASE_FAILED": 7,
                  "CANNOT_VOID": 3,
                  "RECORD_NOT_FOUND": 4,
                  "MISSING_AUTHORIZATION": 8,
                  "MISSING_PAYMENT_LOCK_ENTRY": 9,
                  "OTHER": 5
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.reverse?.nested?.ReverseError) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ReverseError @ squareup/payments/reverse.proto at 7:1
 */
export const ReverseError = $root.lookupEnum('squareup.payments.reverse.ReverseError').values;